import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_cookie_notice = _resolveComponent("app-cookie-notice")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_user_email_activate = _resolveComponent("app-user-email-activate")!
  const _component_CreateStartupProfileModal = _resolveComponent("CreateStartupProfileModal")!
  const _component_StartupNextModal = _resolveComponent("StartupNextModal")!
  const _component_SurveyModal = _resolveComponent("SurveyModal")!
  const _component_app_user_onboard_info = _resolveComponent("app-user-onboard-info")!
  const _component_app_user_main_skills_modal = _resolveComponent("app-user-main-skills-modal")!
  const _component_app_user_add_edu_modal = _resolveComponent("app-user-add-edu-modal")!
  const _component_app_user_standardtests_modal = _resolveComponent("app-user-standardtests-modal")!
  const _component_app_user_avatar_modal = _resolveComponent("app-user-avatar-modal")!
  const _component_StartupCofoundersModal = _resolveComponent("StartupCofoundersModal")!
  const _component_CreateOpportunityModal = _resolveComponent("CreateOpportunityModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_cookie_notice),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ]),
    (_ctx.user && _ctx.user.type === 'founder')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_app_user_email_activate, {
            onChecked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toogleVariable('checkedEmailActivate', true))),
            onOpened: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toogleVariable('openedEmailActivate', true))),
            onClosed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toogleVariable('openedEmailActivate', false)))
          }),
          (_ctx.fetchedBusinesses && _ctx.vIf('Startup'))
            ? (_openBlock(), _createBlock(_component_CreateStartupProfileModal, {
                key: 0,
                onChecked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toogleVariable('checkedStartup', true))),
                onOpened: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toogleVariable('openedStartup', true))),
                onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toogleVariable('openedStartup', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.business && _ctx.vIf('StartupFuture'))
            ? (_openBlock(), _createBlock(_component_StartupNextModal, {
                key: 1,
                business: _ctx.business,
                onChecked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toogleVariable('checkedStartupFuture', true))),
                onOpened: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toogleVariable('openedStartupFuture', true))),
                onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toogleVariable('openedStartupFuture', false)))
              }, null, 8, ["business"]))
            : _createCommentVNode("", true),
          (_ctx.vIf('Survey'))
            ? (_openBlock(), _createBlock(_component_SurveyModal, {
                key: 2,
                onChecked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toogleVariable('checkedSurvey', true))),
                onOpened: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toogleVariable('openedSurvey', true))),
                onClosed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toogleVariable('openedSurvey', false))),
                user: _ctx.user
              }, null, 8, ["user"]))
            : _createCommentVNode("", true),
          (_ctx.vIf('OnboardInfo'))
            ? (_openBlock(), _createBlock(_component_app_user_onboard_info, {
                key: 3,
                onChecked: _cache[12] || (_cache[12] = ($event: any) => (_ctx.toogleVariable('checkedOnboardInfo', true))),
                onOpened: _cache[13] || (_cache[13] = ($event: any) => (_ctx.toogleVariable('openedOnboardInfo', true))),
                onClosed: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toogleVariable('openedOnboardInfo', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.vIf('MainSkills'))
            ? (_openBlock(), _createBlock(_component_app_user_main_skills_modal, {
                key: 4,
                onChecked: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toogleVariable('checkedMainSkills', true))),
                onOpened: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toogleVariable('openedMainSkills', true))),
                onClosed: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toogleVariable('openedMainSkills', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.vIf('Education'))
            ? (_openBlock(), _createBlock(_component_app_user_add_edu_modal, {
                key: 5,
                onChecked: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toogleVariable('checkedEducation', true))),
                onOpened: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toogleVariable('openedEducation', true))),
                onClosed: _cache[20] || (_cache[20] = ($event: any) => (_ctx.toogleVariable('openedEducation', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.vIf('StandardTest'))
            ? (_openBlock(), _createBlock(_component_app_user_standardtests_modal, {
                key: 6,
                onChecked: _cache[21] || (_cache[21] = ($event: any) => (_ctx.toogleVariable('checkedStandardTest', true))),
                onOpened: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toogleVariable('openedStandardTest', true))),
                onClosed: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toogleVariable('openedStandardTest', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.vIf('Avatar'))
            ? (_openBlock(), _createBlock(_component_app_user_avatar_modal, {
                key: 7,
                onChecked: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toogleVariable('checkedAvatar', true))),
                onOpened: _cache[25] || (_cache[25] = ($event: any) => (_ctx.toogleVariable('openedAvatar', true))),
                onClosed: _cache[26] || (_cache[26] = ($event: any) => (_ctx.toogleVariable('openedAvatar', false)))
              }))
            : _createCommentVNode("", true),
          (_ctx.vIf('StartupCofounders'))
            ? (_openBlock(), _createBlock(_component_StartupCofoundersModal, {
                key: 8,
                business: _ctx.business,
                onChecked: _cache[27] || (_cache[27] = ($event: any) => (_ctx.toogleVariable('checkedStartupCofounders', true))),
                onOpened: _cache[28] || (_cache[28] = ($event: any) => (_ctx.toogleVariable('openedStartupCofounders', true))),
                onClosed: _cache[29] || (_cache[29] = ($event: any) => (_ctx.toogleVariable('openedStartupCofounders', false)))
              }, null, 8, ["business"]))
            : _createCommentVNode("", true),
          (_ctx.vIf('Opportunity'))
            ? (_openBlock(), _createBlock(_component_CreateOpportunityModal, {
                key: 9,
                onChecked: _cache[30] || (_cache[30] = ($event: any) => (_ctx.toogleVariable('checkedOpportunity', true))),
                onOpened: _cache[31] || (_cache[31] = ($event: any) => (_ctx.toogleVariable('openedOpportunity', true))),
                onClosed: _cache[32] || (_cache[32] = ($event: any) => (_ctx.toogleVariable('openedOpportunity', false)))
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}